// src/services/storage/StorageContext.tsx
// Context React pour injecter le StorageService

import React, { createContext, useContext, ReactNode } from 'react';
import { StorageService } from './types';
import { BrowserStorageService } from './BrowserStorageService';

// Instance par défaut (localStorage réel)
const defaultService = new BrowserStorageService();

export const StorageContext = createContext<StorageService>(defaultService);

/**
 * Hook pour accéder au StorageService
 * @returns StorageService - le service de stockage injecté
 */
export const useStorageService = (): StorageService => {
	return useContext(StorageContext);
};

interface StorageProviderProps {
	children: ReactNode;
	service?: StorageService;
}

/**
 * Provider pour injecter un StorageService personnalisé
 * Utile pour les tests avec MockStorageService
 */
export const StorageProvider: React.FC<StorageProviderProps> = ({
	children,
	service = defaultService
}) => {
	return (
		<StorageContext.Provider value={service}>
			{children}
		</StorageContext.Provider>
	);
};

